module.exports = __webpack_public_path__ + "static/AssistHeroBg2-d6ad9331bfff1b161d218b6f649826e1.png";